<template>
  <div class="produto-cdlsaude-cadastrofinal">
    <div class="content">
      <div class="row mb-3">
        <div class="col-md-6">
          <Titulo
            title="Pagamento"
            description="Efetue o pagamento inicial do seu plano, retroativo a data vigente."
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <Carrinho
            :title="'Informações do Plano'"
            :list="lista"
            v-if="lista.length"
          />
          <section v-else>
            <loading />
          </section>
        </div>
        <div class="col-md-6 mt-3 mt-md-0">
          <FormasPagamento
            :formasPagamento="formasPagamento"
            :loading="loading"
            @method="efetuarpagamento"
          />
        </div>
      </div>
    </div>
    <div class="row mt-5 flex-column-reverse flex-md-row">
      <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
        <Botao
          title="Voltar"
          link="/produto/cdl-saude-plano/listavidas"
          nameClass="btn btn-outline-secondary btn-lg btn-block"
          >VOLTAR</Botao
        >
      </div>
    </div>
    <div class="py-5"></div>
  </div>
</template>

<script>
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";
import Carrinho from "@/components/pagamento/Carrinho";
import FormasPagamento from "@/components/pagamento/MetodosPagamento";
import { formatDate } from "../../../helpers.js";

export default {
  name: "ListaVidas",
  components: { Titulo, Botao, Carrinho, FormasPagamento },
  data() {
    return {
      produto: {
        nome: "CDL Saúde",
        id: "SPC Saude",
      },
      breadcrumb: [
        {
          nome: "CDL Saúde",
          id: "CDL Saude",
          link: "/produto/cdl-saude",
        },
        {
          nome: "Pagamento",
          id: "pagamento",
        },
      ],
      lista: [],
      formasPagamento: {
        cartaocredito: true,
        boleto: {
          status: true,
          msg: "Atenção! A data de vigência para pagamento com boleto acresce 2 dias úteis.",
        },
      },
      dadosVida: [],
      loading: false,
      valorTotal: 0,
    };
  },
  methods: {
    montarDados() {
      // Vidas do pre cadastro - um passo antes de enviar os documentos
      this.$http
        .get(
          `/api/CdlBh/ConsultarSamVidaArta?cpfTitular=${this.urlParams.cpfTitular}`
        )
        .then((response) => {
          this.dadosVida = response.data.lista;
          this.dadosVida.forEach((el) => {
            if (el.status === "PREVIDA") {
              var dataVigencia = new Date(el.datavigencia);

              var descricaoCarrinho = {
                desc: `Plano de saúde CDL ${this.dadosVida[0].operadora} -
                ${this.dadosVida[0].assistencia}`,
                info:
                  "Titular: " +
                  el.nome +
                  (el.mensalidade
                    ? " (Mensalidade + Taxa + Prórata)"
                    : " (Taxa + Prórata)"),
                infoExtra: "Data Vigência: " + formatDate(dataVigencia),
                value: el.totaL_VIDA,
              };
              this.lista.push(descricaoCarrinho);
            }

            el.dependentes.forEach((dep) => {
              if (dep.status === "PREVIDA") {
                dataVigencia = new Date(dep.datavigencia);
                var descricaoCarrinho = {
                  desc: `Plano de saúde CDL ${this.dadosVida[0].operadora} -
                  ${this.dadosVida[0].assistencia}`,
                  info:
                    "Dependente: " +
                    dep.nome +
                    (dep.mensalidade
                      ? " (Mensalidade + Taxa + Prórata)"
                      : " (Taxa + Prórata)"),
                  infoExtra: "Data Vigência: " + formatDate(dataVigencia),
                  value: dep.totaL_VIDA,
                };
                this.lista.push(descricaoCarrinho);
              }
            });
          });
        });
    },
    async efetuarpagamento(payload) {
      this.loading = true;
      if (payload.type === "Boleto") {
        this.$http
          .post("/api/GestaoSaude/RegistrarBoletoSaude", {
            chamados: [this.dadosVida[0].codchamado],
          })
          .then((response) => {
            this.loading = false;
            if (response.data.sucesso) {
              localStorage.removeItem("cdlsaude_cadastro");
              this.$toast.open({
                message:
                  "Boleto gerado com sucesso! Redirecionando para a lista de vidas",
                type: "success",
              });
              setTimeout(() => {
                this.$router.push({
                  name: "listavidas",
                });
              }, 2000);
              window.open(response.data.urlBoleto);
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$toast.open({
              message: error.message,
              type: "warning",
            });
          });
      } else if (payload.type === "Cartao") {
        const dadosCartao = payload.payload.dataCard;
        this.$http
          .post("/api/GestaoSaude/RegistrarPagamentoCreditoSaude", {
            nomeCartao: dadosCartao.nomeCartao,
            numeroCartao: dadosCartao.numeroCartao,
            dataExpiracaoCartao: dadosCartao.dataExpiracaoCartao,
            codigoValidacaoCartao: dadosCartao.codigoValidacaoCartao,
            parcelamento: dadosCartao.parcelamento,
            chamados: [this.dadosVida[0].codchamado],
          })
          .then((response) => {
            if (response.data.sucesso) {
              localStorage.removeItem("cdlsaude_cadastro");
              this.$toast.open({
                message:
                  "Pagamento finalizado com sucesso! Redirecionando para a lista de vidas",
                type: "success",
              });
              this.loading = false;
              setTimeout(() => {
                this.$router.push({
                  name: "listavidas",
                });
              }, 2000);
            } else {
              this.loading = false;
              this.$toast.open({
                message:
                  "Erro ao processar seu pagamento, verifique os dados do cartão e tente novamente.",
                type: "warning",
              });
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$toast.open({
              message: error.message,
              type: "warning",
            });
          });
      }
    },
  },
  computed: {
    urlParams() {
      return this.$route.params;
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.montarDados();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
@import "@/assets/scss/_vars.scss";
.produto-cdlsaude-cadastrofinal /deep/ {
  @import "@/assets/scss/_vue-formulate.scss";
  .formulate-input {
    margin-top: 1rem;
    .formulate-input-wrapper {
    }
    .formulate-input-label {
      margin-bottom: 0.5rem;
    }

    .formulate-input-element {
      padding: 5px;
      background: $dark-100;
      input,
      select {
        background: $dark-100;
      }
    }
    &[data-classification="select"] {
      select {
        width: 100%;
      }
    }
    &[data-classification="button"] {
      &,
      .formulate-input-element {
        padding: 0;
        background-color: transparent;
      }
      button {
        // Style button inputs
      }
    }
  }
}
.label {
  font-weight: 300;
  font-size: 1rem;
  margin-bottom: 3px;
  text-transform: capitalize;
}
.value {
  font-weight: bold;
  font-size: 1rem;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
</style>
